var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1545_8788)",
    filter: "url(#filter0_d_1545_8788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9333 11.5331C15.7333 11.5331 17.1333 10.0664 17.1333 8.26641C17.1333 6.46641 15.6666 5.06641 13.8666 5.06641C12.0666 5.06641 10.6666 6.53307 10.6666 8.26641C10.6666 10.0664 12.1333 11.5331 13.9333 11.5331ZM13.8666 6.39974C13.9333 6.39974 13.9333 6.39974 13.8666 6.39974C14.9333 6.39974 15.8 7.26641 15.8 8.33307C15.8 9.39974 14.9333 10.1997 13.8666 10.1997C12.8 10.1997 12 9.33307 12 8.33307C12 7.26641 12.8666 6.39974 13.8666 6.39974Z",
    fill: "#29406C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 11.1336C22.5333 10.0003 20.8667 9.40026 19.1333 9.46693H18.6C18.4667 10.0003 18.2667 10.4669 18 10.8669C18.4 10.8003 18.7333 10.8003 19.1333 10.8003C20.4 10.7336 21.6667 11.1336 22.6667 11.8669V16.6669H24V11.3336L23.8 11.1336Z",
    fill: "#29406C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 5.19954C17.9333 4.39954 18.8666 3.99954 19.7333 4.33288C20.5333 4.66621 20.9333 5.59954 20.6 6.46621C20.3333 7.06621 19.7333 7.46621 19.1333 7.46621C19 7.46621 18.8 7.46621 18.6666 7.39954C18.7333 7.73288 18.7333 8.06621 18.7333 8.33288V8.73288C18.8666 8.73288 19 8.79954 19.1333 8.79954C20.8 8.79954 22.1333 7.46621 22.1333 5.86621C22.1333 4.19954 20.8 2.86621 19.2 2.86621C18.1333 2.86621 17.2 3.39954 16.6666 4.33288C17 4.53288 17.3333 4.79954 17.6 5.19954Z",
    fill: "#29406C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.9333C9.73333 10.5333 9.53333 10.0667 9.4 9.53335H8.86667C7.13333 9.46668 5.46667 10.0667 4.2 11.1333L4 11.3333V16.6667H5.33333V11.8667C6.4 11.1333 7.6 10.7333 8.86667 10.8C9.26667 10.8 9.66667 10.8667 10 10.9333Z",
    fill: "#29406C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86668 8.73311C9.00001 8.73311 9.13334 8.73311 9.26668 8.66645V8.26645C9.26668 7.93311 9.26668 7.59978 9.33334 7.33311C9.20001 7.39978 9.00001 7.39978 8.86668 7.39978C8.00001 7.39978 7.26668 6.66645 7.26668 5.79978C7.26668 4.93311 8.00001 4.19978 8.86668 4.19978C9.53334 4.19978 10.1333 4.59978 10.4 5.19978C10.6667 4.86645 11.0667 4.53311 11.4 4.26645C10.5333 2.86645 8.73334 2.39978 7.33334 3.26645C5.93334 4.13311 5.46668 5.93311 6.33334 7.33311C6.86668 8.19978 7.80001 8.73311 8.86668 8.73311Z",
    fill: "#29406C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 15.1333L19.2666 14.9333C17.9333 13.4667 16.0666 12.6 14.0666 12.6667C12.0666 12.6 10.1333 13.4667 8.79996 14.9333L8.66663 15.1333V20.2C8.66663 20.8 9.13329 21.3333 9.79996 21.3333H18.3333C18.9333 21.3333 19.4666 20.8 19.4666 20.2V15.1333H19.4ZM18.0666 20H9.99996V15.6C11.0666 14.5333 12.5333 14 14.0666 14C15.5333 13.9333 17 14.5333 18.0666 15.6V20Z",
    fill: "#29406C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1545_8788",
    x: -2,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1545_8788"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1545_8788",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1545_8788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientBlue);
export default __webpack_public_path__ + "static/media/client-blue.183b5fd78f462d4464dba97457772353.svg";
export { ForwardRef as ReactComponent };